import React, { useState } from "react";
import "./index.less";
import { GroupList, GroupListProps } from "../GroupList";
import { ContactListProps } from "../ContactList";
import { useTranslate } from "@obsbot/remo-i18n";
// import { Button } from "antd";
// import { AddFriendIcon } from "../../SvgIconCom/FriendsChatIcon";
// import Icon from "@ant-design/icons";
import { BottomTools, BottomToolsProps } from "../BottomTools";
import { withRemoServices } from "@obsbot/remo-pages/src/components/RemoServicesContext";
import { PrivateList } from "../PrivateList";
import { useChannelRoomStore } from "@obsbot/remo-stores";

export interface ChatSideBarProps extends GroupListProps, ContactListProps, BottomToolsProps {
    onClick?: (key: string) => void;
    onHandleLeave?: () => void;
    toSetting?: (toVideo?: boolean) => void;
}
export const ChatSideBar: React.FC<ChatSideBarProps> = withRemoServices("videoChat")(({
    onClick,
    onHandleLeave,
    videoChat: rtc,
    toSetting,
}) => {
    const t = useTranslate(); // Use the useTranslate hook to get the translation
    const { isJoinedRTC } = useChannelRoomStore();
    const [selectedSideKey, setSelectedSideKey] = useState<string | undefined>("group"); // 用于跟踪选中的用户或分组
    const isSelectedClick = (type: string): void => {
        setSelectedSideKey(type); // 更新选中的用户或分组
    };

    return (
        <div className="chat-side-bar">
            <div className="chat-list-friends">
                <div className="chat-title">
                    {t("chat.sidebar-friends")}
                    {/* <Button icon={<Icon component={AddFriendIcon} />}>
                        {t("chat.add-friend")}
                    </Button> */}
                </div>
                <GroupList
                    isSelectedClick={isSelectedClick.bind(this, "group")}
                    selectedGroup={selectedSideKey === "group"}
                    onClick={onClick}
                />
            </div>
            <div className={`chat-list-msg ${isJoinedRTC ? "bottom-whole-tool" : ""}`}>
                <div className="chat-title">{t("chat.sidebar-msg")}</div>
                <PrivateList
                    hasSelectedUser={selectedSideKey === "msg"}
                    isSelectedClick={isSelectedClick.bind(this, "msg")}
                    onClick={onClick}
                />
            </div>
            <div className="chat-list-tools">
                <BottomTools rtc={rtc} toSetting={toSetting} onHandleLeave={onHandleLeave} />
            </div>
        </div>
    );
});
